import { Component, Input, OnInit } from '@angular/core';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { HTags } from '@shared/src/datatypes/HTags';
import { BookingDto } from '@shared/src/dtos/booking/BookingDto';
import { iBooking } from '@shared/src/dtos/booking/iBooking';

@Component({
  selector: 'shared-booking-card',
  templateUrl: './shared.booking.card.component.html',
  styleUrls: ['./shared.booking.card.component.scss']
})
export class SharedBookingCardComponent implements OnInit {

  constructor(protected bookingController: BookingController) { }

  ngOnInit(): void { }

  private _booking: iBooking;
  @Input() public set booking(v: iBooking) {
    if (v && this._booking && JSON.stringify(v) === JSON.stringify(this._booking))
      return;

    if (v) {
      v.userTags = HTags.buildFromDto(v.userTags);
      v.internalTags = HTags.buildFromDto(v.internalTags);
    }

    this._booking = v;

    this.calculateGeneralClass();
  }

  public get booking(): iBooking {
    return this._booking;
  }

  public generalClass: string = "";
  public calculateGeneralClass() {
    this.generalClass = SharedBookingCardComponent.getGeneralClass(this.booking);
  }
  public static getGeneralClass(booking: iBooking): string {
    if (!booking)
      return "";
    let generalClass = HTags.convertToStringWithDelimiter(booking.internalTags, " ");
    generalClass += " " + booking.status;
    return generalClass;
  }



  pretty(value: any): string {
    return JSON.stringify(value);
  }
}
